/* ── PCX Featured Collections: tab interaction ───────────────────
   Manual activation: arrows move focus only; Enter/Space activates.
   ARIA Authoring Practices Guide — Tabs, Manual Activation pattern.
   ─────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  function initFeaturedCollections(wrapper) {
    var tabs = Array.from(wrapper.querySelectorAll('[role="tab"]'));
    var panels = Array.from(wrapper.querySelectorAll('[role="tabpanel"]'));

    if (!tabs.length) return;

    function activate(tab) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      panels.forEach(function (p) {
        p.hidden = true;
      });

      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      var panelId = tab.getAttribute('aria-controls');
      var panel = wrapper.querySelector('#' + panelId);
      if (panel) panel.hidden = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab);
        var next;

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          next = tabs[(idx + 1) % tabs.length];
          next.focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          next = tabs[(idx - 1 + tabs.length) % tabs.length];
          next.focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          tabs[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          tabs[tabs.length - 1].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(tab);
        }
      });
    });

    // Set initial state: first tab active, all others hidden
    if (tabs.length > 0) {
      activate(tabs[0]);
    }
  }

  document.querySelectorAll('[data-pcx-featured-collections]').forEach(initFeaturedCollections);
})();
